// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3yG4T","inputDescription":"styles_inputDescription__22kgr"};